/* eslint-disable max-len */
import React from 'react';
function UploadOutlined() {
    return (React.createElement("g", null,
        React.createElement("path", { id: "outline/upload", fillRule: "evenodd", clipRule: "evenodd", d: "M15 16.5V10.5H19L12 3.5L5 10.5H9V16.5H15ZM12 6.33L14.17 8.5H13V14.5H11V8.5H9.83L12 6.33ZM19 20.5V18.5H5V20.5H19Z" })));
}
export default UploadOutlined;
